import { useState } from 'react';
import { useAppAuth, useAppAuthActions } from '../hooks/useAppAuth';
import TenantSwitcher from '../components/TenantSwitcher';
import ApiService from '../services/api.service';

export default function TenantNotFound() {
  const { user } = useAppAuth();
  const { logout } = useAppAuthActions();
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const isPliableUser = user?.email?.endsWith('@pliable.co');

  const handleCreateTenant = async () => {
    setIsCreating(true);
    setError(null);
    try {
      await ApiService.getInstance().request('POST', '/onboarding/init-tenant');
      window.location.reload();
    } catch (e: any) {
      setError(e?.message ?? 'Something went wrong. Please try again.');
      setIsCreating(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-6 rounded-lg border p-8 shadow-sm">
        <div className="text-center space-y-2">
          <p className="text-6xl font-light text-muted-foreground">Oh No!</p>
          <h1 className="text-xl font-semibold">Tenant Not Found</h1>
          <p className="text-sm text-muted-foreground">
            This tenant no longer exists or you don't have access to it.
          </p>
        </div>

        {user && (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground text-center">
              Switch to another account:
            </p>
            <TenantSwitcher />
          </div>
        )}

        {isPliableUser && (
          <div className="space-y-2">
            <button
              onClick={handleCreateTenant}
              disabled={isCreating}
              className="w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
            >
              {isCreating ? 'Creating...' : 'Create Tenant'}
            </button>
            {error && (
              <p className="text-sm text-destructive text-center">{error}</p>
            )}
          </div>
        )}

        <div className="text-center">
          <button
            onClick={() => logout()}
            className="text-sm text-muted-foreground underline hover:text-foreground"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
